import { Injectable } from '@angular/core';
import { equalTo, orderByChild } from '@angular/fire/database';
import { Food } from '../models';
import { DatabaseService } from './database.service';
import { HelperService } from './helper.service';

export interface FoodCategory {
  id: string;
  children: string[];
  description?: string;
  foods: {[foodId: string]: boolean};
  level?: number;
  title: string;
  topLevel?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class FoodService {
  constructor(
    private databaseService: DatabaseService,
    private helperService: HelperService,
  ) { }
   
    async getFoodAsPromise(foodId): Promise<Food> {
      const snap = await this.databaseService.getSnapshot(`foods/${foodId}`);
      if(snap) {
        const food = new Food(snap);
        food.uid = foodId;
        food.$id = foodId;
        food.id = foodId;  
        return food 
      } else {
        throw "not-found"
      }
    }  

    async getFoodByUPC(upc): Promise<Food> {
      const snap = await this.databaseService.getSnapshot(`foods`, orderByChild('upc'), equalTo(upc));
      if(snap) {
        const keys = Object.keys(snap);
        const food = new Food(snap[keys[0]]);
        food.uid = keys[0];
        food.$id = keys[0];
        food.id = keys[0];  
        return food 
      } else {
        return undefined
      }
    }  

    public getSystemFoodsList() {
      return this.databaseService.getListByRefTest(`foods`, orderByChild("organization"), equalTo("system"));
    }

    public async getSystemFoodsAsPromise() {
      const snap = await this.databaseService.getSnapshot(`foods`, orderByChild("organization"), equalTo("system"));
      return snap? this.helperService.transformFirebaseObjectToArray(snap).map((food) => {return new Food(food)}) : [];
    }

    updateFood(foodId: string, data: Partial<Food>) {
      return this.databaseService.updateRef(`foods/${foodId}`, data);
    }

    deleteFood(foodId: string) {
      return this.databaseService.removeRef(`foods/${foodId}`);
    }

    async updateFoodCounter(foodId: string) {
      const counter = await this.databaseService.getSnapshot(`foods/${foodId}/counter`);
      return this.databaseService.setRef(`foods/${foodId}/counter`, isNaN(counter)? 1 : counter + 1);
    }

    public getOrganizationFoodsList(organization) {
      return this.databaseService.getListByRefTest(`foods`, orderByChild("organization"), equalTo(organization));
    }

    public async getOrganizationFoodsAsPromise(organization) {
      const snap = await this.databaseService.getSnapshot(`foods`, orderByChild("organization"), equalTo(organization));
      return snap? this.helperService.transformFirebaseObjectToArray(snap).map((food) => {return new Food(food)}) : [];
    }

    public async getPersonalFoodsAsPromise(userId: string) {
      const snap = await this.databaseService.getSnapshot(`foods`, orderByChild("createdBy"), equalTo(userId));
      return snap? this.helperService.transformFirebaseObjectToArray(snap).map((food) => {return new Food(food)}) : [];
    }

    public async getFoodCategories(): Promise<FoodCategory[] | null> {
      const snap = await this.databaseService.getSnapshot(`food-categories`);
      return snap? this.helperService.transformFirebaseObjectToArray(snap) :  null;
    }

    createfood(foodObj: any) {      
      return this.databaseService.pushByRef('foods', foodObj);
    }
}
